import { h, Component } from 'preact';
import style from './style';
import { themes, icons } from './../../config'

export default class SocialIcons extends Component {
	render(props, state) {
    let templateTheme = this.props.template.template_bg_color || 'light';
    let themeConfig = themes.variants[templateTheme];
    let socialIcon = { color: themeConfig.TEXT };

		return (
      <div class={'socialIconsContainer'}>
        <div class={'socialIconsWrapper'}>
          {this.props.icons && Object.keys(this.props.icons).map(item => {
            if (this.props.icons[item]) {
              return (
                <a class={style.socialIcon} style={socialIcon} href={this.props.icons[item]} target="_top">
                  <i class={icons[item]} />
                </a>
              )
            }
          })}
        </div>
      </div>
		);
	}

  handleClose() {
    this.props.destroyTag();
  }
}



// WEBPACK FOOTER //
// ./components/spareparts/social/index.js